import { Customer } from "./Customer";

export enum XAICallStatus {
  Pending = "PENDING",
  Added = "ADDED",
  Error = "ERROR",
  Success = "SUCCESS",
  Ongoing = "ONGOING",
}

export enum XAIClientMood {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
  NÖTR = "NÖTR",
  NEUTRAL = "NEUTRAL",
  UNKNOWN = "UNKNOWN",
}

export enum XAIDisconnectionResult {
  AGENT_HANGUP = "AGENT_HANGUP",
  USER_HANGUP = "USER_HANGUP",
  DIAL_BUSY = "DIAL_BUSY",
  VOICEMAIL_REACHED = "VOICEMAIL_REACHED",
  TELEPHONY_PROVIDER_PERMISSION_DENIED = "TELEPHONY_PROVIDER_PERMISSION_DENIED",
  TELEPHONY_PROVIDER_UNAVAILABLE = "TELEPHONY_PROVIDER_UNAVAILABLE",
  ERROR_NO_AUDIO_RECEIVED = "ERROR_NO_AUDIO_RECEIVED",
  INVALID_DESTINATION = "INVALID_DESTINATION",
  DIAL_FAILED = "DIAL_FAILED",
  DIAL_NO_ANSWER = "DIAL_NO_ANSWER",
  INACTIVITY = "INACTIVITY",
}

export enum GenderEnum {
  Male = "MALE",
  Female = "FEMALE",
  Other = "OTHER",
}

export type XAILead = {
  id: string;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;

  firstName: string;
  lastName: string;
  email: string;
  lastVisit: string;
  status: string;
  tag: string;
  note: string | null;
  language: string;
  birthDate: string | null;
  brand: string;
  businessUnit: string;
  clientSummary: string | null;
  lastIpAddress: string | null;
  lastCountry: string | null;
  agent: string;
  summary: string | null;
  callStatus: XAICallStatus;
  error: string | null;
  talkingPoints: string | null;
  customerId: string;
  customer?: Customer;

  extraData: null | {
    aiModelId?: string;
    brokerName?: string;
    preferredPhoneNumber?: string;
    [key: string]: any;
  };
};

export type XAICallRawCallback = {
  id: string;
  status: string;
  call_id: string;
  summary: string;
  callCost: string;
  nextStep: string;
  VoiceFile: string;
  agentName: string;
  doNotCall: string;
  ClientMood: string;
  callStatus: XAICallStatus;
  durationMs: string;
  description: string;
  clientSummary: string;
  disconnectionReasult: string;

  [key: string]: any;
};

export type XAICallLog = {
  id: string;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;

  leadId: string | null;
  lead?: XAILead;
  status: string;
  callbackError: string | null;
  customerId: string | null;
  customer?: Customer;
  appointmentTime?: string | null;
  rawCallback: XAICallRawCallback;
};

export type XAICall = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;

  leadId: string | null;
  lead?: XAILead;
  status: string;
  callId: string;
  summary: string;
  callCost: string;
  nextStep: string;
  voiceFile: string;
  agentName: string;
  doNotCall: boolean;
  clientMood: XAIClientMood;
  callStatus: XAICallStatus;
  durationMs: string;
  transcript: string | null;
  description: string;
  clientSummary: string;
  disconnectionResult: XAIDisconnectionResult;
  customerId: string | null;
  customer?: Customer;
  sentiment: string | null;
  histories?: XAICallLog[];
  keywords: string[] | null;
};

export type XAICallModel = {
  id: string;
  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;

  aiModelId: string;
  name: string;
  language: string | null;
  gender: GenderEnum | null;
  personality: string | null;
  purpose: string | null;
  description: string | null;
  isDisabled: boolean;
};

export type XAICallLogsDashboardResponse = {
  totalCallCount: string;
  dailyCallCount: {
    call_date: string;
    call_count: number;
  }[];
  groupByCallStatusCount: {
    call_status: XAICallStatus;
    count: number;
  }[];
  groupByAIModelCount: {
    ai_model_id: string;
    ai_model_name: string;
    count: number;
  }[];
  groupByStatusCount: {
    status: string;
    count: number;
  }[];
  groupByCustomerCount: {
    customer_id: string;
    customer_name: string;
    customer_logo: string;
    count: number;
  }[];
};

export type XAILeadsDashboardResponse = {
  totalLeadCount: string;
  dailyLeadCount: {
    lead_date: string;
    count: number;
  }[];
  groupByCallStatusCount: {
    call_status: XAICallStatus;
    count: number;
  }[];
  groupByCustomerCount: {
    customer_id: string;
    customer_name: string;
    customer_logo: string;
    count: number;
  }[];
  groupByLanguageCount: {
    language: string;
    count: number;
  }[];
  groupByCountryCount: {
    country: string;
    count: number;
  }[];
};
